import { FC, SVGProps, memo, useMemo } from 'react'
import classNames from 'classnames'
import { CrewCountBadge } from 'components/crewCountBadge/crewCountBadge'

/** バッジの色 */
export type BadgeColor = 'Blue' | 'Orange' | 'Red'

/**
 * タブコンポーネントのプロパティ
 *  selected:
 *    チャットパネルのように、URLを持たず画面遷移を伴わない場合に指定する
 */
export type CrewTabProps = {
  text: string
  selected: boolean
  onClick: () => void
  icon?: (props: SVGProps<SVGSVGElement>) => React.ReactElement
  // バッジを非表示にしたい場合はbadgeCountをundefinedにする
  badgeCount?: number
  badgeColor?: BadgeColor
}

/**
 * タブコンポーネント
 */
export const CrewTab: FC<CrewTabProps> = memo((props) => {
  // props.selectedで選択状態を制御するため、
  // 選択されたタブが自身を示すかどうかを返す
  const isSelectedTab = useMemo(() => {
    return props.selected
  }, [props.selected])

  const selectedTabClassNames = useMemo(() => {
    return classNames(
      'flex flex-row gap-1 items-center h-full p-2 cursor-pointer',
      'font-bold rounded-t-md border-b-2 text-crew-gray-900 dark:text-crew-gray-50 crew-bg-default border-b-crew-sky-blue-600 dark:border-b-crew-sky-blue-600'
    )
  }, [])

  const selectedBadgeClassNames = useMemo(() => {
    return classNames(
      props.badgeColor === 'Red'
        ? 'crew-badge-red-inverted'
        : props.badgeColor === 'Orange'
          ? 'crew-badge-orange-inverted'
          : props.badgeColor === 'Blue'
            ? 'crew-badge-blue-inverted'
            : ''
    )
  }, [props.badgeColor])

  const SvgIcon = props.icon

  const hiddenBadge = props.badgeCount === undefined || props.badgeCount <= 0

  return isSelectedTab ? (
    <div className={selectedTabClassNames}>
      {SvgIcon && <SvgIcon width={24} height={24} />}
      <span className="font-bold whitespace-nowrap">{props.text}</span>
      {/* 選択状態のバッジ */}
      {!hiddenBadge && (
        <CrewCountBadge displayColor={selectedBadgeClassNames}>
          {props.badgeCount}
        </CrewCountBadge>
      )}
    </div>
  ) : (
    <div
      className="flex flex-row gap-1 items-center h-full p-2 crew-text-gray-4 cursor-pointer hover:font-bold"
      onClick={props.onClick}
    >
      {SvgIcon && <SvgIcon width={24} height={24} />}
      <span className="whitespace-nowrap">{props.text}</span>

      {/* 未選択状態のバッジ */}
      {!hiddenBadge && (
        <CrewCountBadge displayColor="crew-badge-gray-inverted">
          {props.badgeCount}
        </CrewCountBadge>
      )}
    </div>
  )
})
